import { Text } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';

const ListInfoBlock = ({
  label = '',
  value = '',
}) => {
  return (
    <div>
      <Text c="#52575C">
        {label}
      </Text>
      {value}
    </div>
  );
};

export default ListInfoBlock;

ListInfoBlock.propTypes = {
  label:PropTypes.string,
  value:PropTypes.node
};
